var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconRepeat = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 12C3.6 12 4 11.6 4 11V9C4 7.3 5.3 6 7 6H18.6L16.3 8.3C15.9 8.7 15.9 9.3 16.3 9.7C16.5 9.9 16.7 10 17 10C17.3 10 17.5 9.9 17.7 9.7L21.7 5.7C21.8 5.6 21.9 5.5 21.9 5.4C22 5.2 22 4.9 21.9 4.6C21.8 4.5 21.8 4.4 21.7 4.3L17.7 0.3C17.3 -0.1 16.7 -0.1 16.3 0.3C15.9 0.7 15.9 1.3 16.3 1.7L18.6 4H7C4.2 4 2 6.2 2 9V11C2 11.6 2.4 12 3 12ZM21 12C20.4 12 20 12.4 20 13V15C20 16.7 18.7 18 17 18H5.4L7.7 15.7C8.1 15.3 8.1 14.7 7.7 14.3C7.3 13.9 6.7 13.9 6.3 14.3L2.3 18.3C2.2 18.4 2.1 18.5 2.1 18.6C2 18.8 2 19.1 2.1 19.4C2.2 19.5 2.2 19.6 2.3 19.7L6.3 23.7C6.5 23.9 6.7 24 7 24C7.3 24 7.5 23.9 7.7 23.7C8.1 23.3 8.1 22.7 7.7 22.3L5.4 20H17C19.8 20 22 17.8 22 15V13C22 12.4 21.6 12 21 12Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconRepeat);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "media/IconRepeat.095b27a5f758cea17ff3c7eb76ce7174.svg";